export default class ArchiveVideos {
  constructor() {
    // Archive Videos
    const select = document.querySelector('section.content .filters select');
    if (select) {
      select.addEventListener('change', () => {
        window.location.href = select.value;
      });
    }
  }
}